module.exports = __webpack_public_path__ + "static/media/55_000045.68ba7488.jpg";